import { useMemo } from 'react';
import { useProductPricingApi } from 'app/common/hooks';
import { get, isEmpty } from 'lodash';
import {
  PRICE_UNAVAILABLE,
  determineProductOrVariantPricing
} from 'app/product/utils/PricingUtils';

function usePriceProducts(products) {
  const { priceInfoResponse, isLoaded } = useProductPricingApi(products);

  return useMemo(() => {
    const prices = new Map();

    // until pricing has loaded, leave products without an entry so they show
    // a loading placeholder rather than "Call for Pricing"
    if (isLoaded || !isEmpty(priceInfoResponse)) {
      for (let product of products) {
        const priceInfoContainer = get(priceInfoResponse, product.id);
        const productPricing = priceInfoContainer
          ? determineProductOrVariantPricing(
              product,
              priceInfoContainer.priceInfo
            )
          : null;
        if (!isEmpty(productPricing)) {
          prices.set(product.id, productPricing);
        } else if (isLoaded) {
          prices.set(product.id, PRICE_UNAVAILABLE);
        }
      }
    }

    return prices;
  }, [products, priceInfoResponse, isLoaded]);
}

export default usePriceProducts;
